import React from 'react';
import './Bayar.css';
import axios from 'axios';
import CurrencyFormat from 'react-currency-format';
import { Link} from "react-router-dom";
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';



class Bayar extends React.Component {

    constructor(props) {
        super(props);
        this.state ={
            products: [],
            totalPrice:'',
            nama: '',
            tgl: '',
            kontak: '',
            alamat: '',
            metodeBayar: 0,
            transferVia: 0,
            checked: true,
            fcm:[],
            estimate: false
        }
        this.onChangeNama = this.onChangeNama.bind(this)
        this.onChangeKontak = this.onChangeKontak.bind(this)
        this.onChangeAlamat = this.onChangeAlamat.bind(this)
        this.onChangeMetodeBayar = this.onChangeMetodeBayar.bind(this)
        this.onChangeTransferVia = this.onChangeTransferVia.bind(this)
        this.onFormSubmit = this.onFormSubmit.bind(this)

    }

    onChangeNama(e) {
        this.setState ({
          nama: e.target.value
        })
    }
    onChangeKontak(e) {
        this.setState ({
          kontak: e.target.value
        })
    }
    onChangeAlamat(e) {
        this.setState ({
          alamat: e.target.value
        })
    }
    onChangeMetodeBayar(e) {
        this.setState ({
          metodeBayar: e.target.value
        })
    }
    onChangeTransferVia(e) {
        this.setState ({
          transferVia: e.target.value
        })
    }

    onFormSubmit(e){
        e.preventDefault();
        let nama = this.state.nama;
        let tgl = new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().slice(0, -5).replace('T',' ');
        let kontak = this.state.kontak;
        let alamat = this.state.alamat;
        let metodeBayar = parseInt(this.state.metodeBayar);
        if (metodeBayar === "0"){
            toast.warn("Pilih salah satu metode pembayaran");
            return false;
        }
        let transferVia = parseInt(this.state.transferVia);
        if (transferVia === "0"){
            transferVia = 4;
            // toast.warn("Pilih salah satu jenis transfer");
            // return false;
        }
        let totalHarga = this.state.totalPrice;
        let products = this.state.products;
        
        const url = 'https://api-ls.faisalhakim.com/public/api/pemesanan';
        const formData = {nama: nama, tgl: tgl, kontak: kontak, alamat: alamat, metodeBayar:metodeBayar, transferVia: transferVia,totalHarga:totalHarga, products:products}
        return  axios.post(url, formData)
                .then(response => console.log(response.status))
                .then(
                localStorage.setItem('count',0),
                localStorage.setItem('cartProducts','')
                )
                .then(
                    this.state.fcm.map((fcm) => {
                        const urlfcm = 'https://fcm.googleapis.com/fcm/send';
                        const formDatafcm = {
                            "notification": {
                                "title": "Ladang Shop",
                                "body": "Pesanan baru telah masuk",
                                "click_action": "https://admin.ladangshop.com/orders",
                                "icon": "https://admin.ladangshop.com/logo512.png"
                            },
                            "to": fcm
                        }
                        const configfcm = {
                            headers: {
                                'Content-Type'  : 'application/json',
                                'Authorization' : 'key=AAAAm7zhE7w:APA91bGSDvQDLhJ4ppSQ6oBlUiMGnYYwAn6DwUoxPtumqA_0QIyWAyMxd15vHMh3wDaCEosDC6rU3ersj-qNGzaPZWLwLRlT8LTZwqbs9fIXqQMjwd5y4EsgeQNtqAbMTPqrdn90pkNb' 
                            }
                        }
                        return  axios.post(urlfcm, formDatafcm,configfcm)
                                .then(response => {  console.log(response.status)})
                                
                                .catch(function (error) {
                                    console.log(error)
                                });
                    })
                )
                .then(
                    confirmAlert({
                        customUI: ({ onClose }) => {
                          return (
                            <div className='custom-ui'>
                                <h5>Transaksi Selesai</h5>
                                <p>Terima Kasih telah berbelanja disini </p>
                                <button type="button" className="btn btn-sm customAlert" onClick={
                                    () => {
                                    window.location.href = "https://ladangshop.faisalhakim.com/home";
                                    onClose()}}>
                                    OK
                                </button>
                            </div>
                          );
                        }
                    })
                )
                .catch(function (error) {
                  if (error.response) {
                    toast.warn("Gagal, "+error.response.data.message);
                  } else if (error.request) {
                    toast.warn("Gagal, "+error.request);
                  } else {
                    toast.warn('Gagal, ', error.message);
                  }
                });
      }

    componentDidMount() {
        let totalPrice = 0;
        JSON.parse(localStorage.getItem('cartProducts')).map(  e => 
            {
            let price = parseInt(e.price.match(/\d/g).join(""))
            let qty = parseInt(e.availability)
            totalPrice += (price*qty)
            if (e.priceChanges === "1"){
                this.setState({
                    estimate : true
                })
            }
            return void 0
            }
        )
        this.setState ({
            products: JSON.parse(localStorage.getItem('cartProducts')),
            totalPrice: totalPrice
        })
        axios.get(`https://api-ls.faisalhakim.com/public/api/userAllFcm`)
        .then(res => {
        const fcm = res.data;
            this.setState ({
                fcm: fcm
            })
        })
        window.scrollTo(0, 0)
    }

    render () {
      return (
        <div className="bayar jumbotron jumbotron-fluid">
            <div className="container shadow mx-auto">
                <h1>Bayar</h1>
                <form onSubmit={this.onFormSubmit}>
                    <div className="form-group text-left">
                        <label className="font-weight-bold">Nama</label>
                        <input type="text" className="form-control"  value={this.state.nama} onChange={this.onChangeNama} placeholder="" required/>
                    </div>
                    <div className="form-group text-left">
                        <label className="font-weight-bold">No Hp</label>
                        <input type="tel" className="form-control" pattern="[0-9]{11,14}" value={this.state.kontak} onChange={this.onChangeKontak}  placeholder="" required/>
                        <small className="form-text text-muted">*Format = 081234567899 , No ini akan dihubungi untuk konfirmasi pemesanan </small>
                    </div>
                    <div className="form-group text-left">
                        <label className="font-weight-bold">Alamat</label>
                        <textarea className="form-control" rows="3" value={this.state.alamat} onChange={this.onChangeAlamat} required></textarea>
                        <small className="form-text text-muted">*Mohon isi lengkap, Pesanan anda akan kami antar ke alamat ini.</small>
                    </div>
                    <div className="form-group text-left">
                        <label className="font-weight-bold">Metode Pembayaran</label>
                        <div className="form-group form-check text-left">
                            {/* <div className="form-check ">
                                <input className="form-check-input" type="radio" name="exampleRadioss" id="exampleRadios1" value="1" onClick={this.onChangeMetodeBayar}/>
                                <label className="form-check-label" >
                                    Transfer
                                </label>
                            </div> */}
                            <div className="form-check ">
                                <input className="form-check-input" type="radio" name="exampleRadioss" id="exampleRadios2" value="2" defaultChecked  onClick={this.onChangeMetodeBayar}/>
                                <label className="form-check-label" >
                                    Bayar di Tempat (Cash on Delivery)
                                </label>
                            </div>
                        </div>
                    </div>
                    {/* <div className="form-group text-left">
                        <label className="font-weight-bold">Transfer melalui</label>
                        <div className="form-group form-check">
                            <div className="form-check ">
                                <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="1"  onClick={this.onChangeTransferVia}/>
                                <label className="form-check-label" >
                                    BCA <br/>(No Rek: 1234-5678-9101)
                                </label>
                            </div>
                            <div className="form-check ">
                                <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="2" onClick={this.onChangeTransferVia}/>
                                <label className="form-check-label" >
                                    Gopay <br/>(No Gopay: 1234-5678-9101)
                                </label>
                            </div>
                            <div className="form-check ">
                                <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="3" onClick={this.onChangeTransferVia}/>
                                <label className="form-check-label" >
                                    OVO <br/>(No OVO: 1234-5678-9101)
                                </label>
                            </div>
                            <div className="form-check ">
                                <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="4" onClick={this.onChangeTransferVia}/>
                                <label className="form-check-label" >
                                    Bayar di Tempat (Cash on Delivery)
                                </label>
                            </div>
                        </div>
                        <small className="form-text text-muted">*Simpan bukti transfer untuk konfirmasi pemesanan</small>
                    </div> */}
                    <div className="container text-left">
                        <label className="font-weight-bold">Produk yang dipesan</label>
                        <table className="table table-bordered table-responsive text-center ">
                            <thead className="backTomato">
                                <tr>
                                    {/* <th scope="col">#</th> */}
                                    <th scope="col" >Nama</th>
                                    <th scope="col">Harga</th>
                                    <th scope="col">Qty</th>
                                    <th scope="col">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                this.state.products.map(
                                    (products, index) => 
                                    <tr key={products.id}>
                                        {/* <td>
                                            {index+1}
                                        </td> */}
                                        <td className="mx-auto my-auto text-left">
                                            {products.title}
                                        </td>
                                        <td className="mx-auto my-auto text-right">
                                            <CurrencyFormat value={parseInt(products.price.match(/\d/g).join(""))} displayType={'text'} thousandSeparator={true} prefix={'Rp.'} />
                                            {products.priceChanges === "1" ? <small className="font-weight-light font-italic"> (Harga Estimasi)</small> : ""}
                                        </td>
                                        <td className="mx-auto my-auto">
                                            {products.availability}
                                        </td>
                                        <td className="mx-auto my-auto text-right">
                                            <CurrencyFormat value={parseInt(products.price.match(/\d/g).join("")) * parseInt(products.availability)} displayType={'text'} thousandSeparator={true} prefix={'Rp.'} />
                                        </td>
                                    </tr>
                                )
                                }
                                <tr className="backTomato">
                                    <td colSpan="3">
                                        Total
                                    </td>
                                    <td className="text-right">
                                        <CurrencyFormat value={this.state.totalPrice} displayType={'text'} thousandSeparator={true} prefix={'Rp.'} />
                                    </td>
                                </tr>
                        </tbody>
                        </table>
                        <p>{this.state.estimate ? <small className="font-weight-light font-italic"> *Harga (Estimasi) bisa saja menyesuaikan sewaktu-waktu, Tim LadangShop akan mengkonfirmasi kepada Anda setelah anda menyelesaikan pesanan ini, Terima Kasih.</small> : ""}</p>
                    </div>
                    <button type="submit" className="btn submit shadow">Selesai</button>
                    &emsp;<Link to="/keranjang"><button type="button" className="btn back shadow">Kembali</button></Link>
                </form>
            </div>
            <ToastContainer
              position="top-center"
              transition={Slide}
              autoClose={3000}
              hideProgressBar
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover={false}
            />
        </div>
      );
    }
  }


export default Bayar;
